import SatelliteDetailPage from "./SatelliteDetailPage";

export default SatelliteDetailPage;